import { useDebounce } from "./useDebounce";

const DELAY_MS = 250;

export const useKeyboardDebounce = <T extends (...args: any[]) => void>(fn: T) => useDebounce(fn, DELAY_MS);